import React from 'react'

export const HeartFilledIcon = () => (
  <svg
    width='26'
    height='24'
    viewBox='0 0 26 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M22.4918 4.00777C20.1488 1.66477 16.3493 1.66477 14.0063 4.00777C13.5863 4.42777 13.2698 4.90477 12.9998 5.40127C12.7298 4.90477 12.4133 4.42627 11.9918 4.00627C9.64877 1.66327 5.84927 1.66327 3.50627 4.00627C1.16327 6.34927 1.16327 10.1488 3.50627 12.4918L12.9998 21.7498L22.4918 12.4918C24.8363 10.1488 24.8363 6.35077 22.4918 4.00777Z'
      fill='#F53158'
      stroke='#F53158'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)
